import { render, staticRenderFns } from "./ReservationAdd.vue?vue&type=template&id=b512b4f2&scoped=true&"
import script from "./ReservationAdd.vue?vue&type=script&lang=js&"
export * from "./ReservationAdd.vue?vue&type=script&lang=js&"
import style0 from "./ReservationAdd.vue?vue&type=style&index=0&id=b512b4f2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b512b4f2",
  null
  
)

export default component.exports